import styles from '@/components/ev-details/v2/RangeInsights.module.css';
import { formatMileage } from '@/utils/formatting';
import React from 'react';
import DetailsComponent from '@/components/ui/cards/DetailsComponent';
interface RangeInsight {
  minValue: number;
  maxValue: number;
}
interface UserVehicleRangeInsights {
  typical: RangeInsight;
  low: RangeInsight;
  high: RangeInsight;
}
interface RangeInsightsProps {
  insights: UserVehicleRangeInsights;
  footerIndex?: number;
}
const RangeInsights: React.FC<RangeInsightsProps> = ({
  insights
}) => {
  const {
    low,
    typical,
    high
  } = insights;
  const metric = false;
  const metricLabel = metric ? 'Kilometers' : 'Miles';
  return <DetailsComponent title="Range Insights (Miles)" onToggle={undefined} toolTipText={'Range insights for 3 sets of driving conditions.'} data-sentry-element="DetailsComponent" data-sentry-component="RangeInsights" data-sentry-source-file="RangeInsights.tsx">
      <div className={styles.content}>
        <div className={styles.leftCol}>
          <div className={styles.title}>Low</div>
          <div className={styles.rangeRow}>
            <div className={styles.range}>
              {formatMileage(Math.round(low.minValue), metric, 'en-US', false)}-
              {formatMileage(Math.round(low.maxValue), metric, 'en-US', false)}
            </div>
          </div>
          <div className={styles.conditions}>
            <div className={styles.condition}>
              <div className={styles.labelAlt}>Urban</div>
              <div className={styles.valueAlt}>0%</div>
            </div>
            <div className={styles.condition}>
              <div className={styles.label}>Motorway</div>
              <div className={styles.value}>100%</div>
            </div>
            <div className={styles.seasons}>
              <div className={styles.season}>
                <span className={styles.icon}>❄️</span> Winter
              </div>
            </div>
          </div>
        </div>
        <div className={styles.centerCol}>
          <div className={styles.title}>Typical</div>
          <div className={styles.rangeRow}>
            <div className={styles.range}>
              {formatMileage(Math.round(typical.minValue), metric, 'en-US', false)}-
              {formatMileage(Math.round(typical.maxValue), metric, 'en-US', false)}
            </div>
          </div>
          <div className={styles.conditions}>
            <div className={styles.condition}>
              <div className={styles.label}>Urban</div>
              <div className={styles.value}>70%</div>
            </div>
            <div className={styles.condition}>
              <div className={styles.label}>Motorway</div>
              <div className={styles.value}>30%</div>
            </div>
            <div className={styles.seasons}>
              <div className={styles.season}>
                <span className={styles.icon}>🍁</span> Autumn
              </div>
              <div className={styles.season}>
                <span className={styles.icon}>🐑</span> Spring
              </div>
            </div>
          </div>
        </div>
        <div className={styles.rightCol}>
          <div className={styles.title}>High</div>
          <div className={styles.rangeRow}>
            <div className={styles.range}>
              {formatMileage(Math.round(high.minValue), metric, 'en-US', false)}-
              {formatMileage(Math.round(high.maxValue), metric, 'en-US', false)}
            </div>
          </div>
          <div className={styles.conditions}>
            <div className={styles.condition}>
              <div className={styles.label}>Urban</div>
              <div className={styles.value}>100%</div>
            </div>
            <div className={styles.condition}>
              <div className={styles.labelAlt}>Motorway</div>
              <div className={styles.valueAlt}>0%</div>
            </div>
            <div className={styles.seasons}>
              <div className={styles.season}>
                <span className={styles.icon}>☀️</span> Summer
              </div>
            </div>
          </div>
        </div>
      </div>
    </DetailsComponent>;
};
export default RangeInsights;